import React, { PropTypes } from 'react'

function Price ({ children, withDecimals }) {
  const precision = withDecimals ? 2 : 0
  const price = parseFloat(children).toFixed(precision)

  return <span>${price}</span>
}

Price.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.number
  ]).isRequired,
  withDecimals: PropTypes.bool
}
Price.defaultProps = {
  withDecimals: false
}

export default Price



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/Price/Price.js